import $ from 'jquery'

$('a').each(function () {
    const $this = $(this);
    const link = $this.attr('href');
    if (
        link && 
        !link.startsWith(window.location.origin) && 
        !link.startsWith('/') && 
        !link.startsWith('#')
    ) {
        $this.attr('target', '_blank');
    }
});
